export default global.Project = {
    selfUrl: 'https://subscription-staging.evolveyou.app',
    debug: false,
    env: 'staging',
    api: 'https://staging.evolveyouapi.com/api/v5',
    ga: 'GTM-PTRJGWR',
    logs: {
        DATA: true,
        STORE: true,
        DISPATCHER: true,
        SERVER: true,
    },
    mobile: {
        // Enabling secured storage for mobile requires installation of https://www.npmjs.com/package/react-native-secured-storage. See README for further instructions on installation
        useSecuredStorage: false,
    },
    loginPage: 'https://login-staging.evolveyou.app',
    accountPage: 'https://account-staging.evolveyou.app',
    loginRedirect: '/account',
    signoutRedirect: '/signout',
    chargebee: {
        site: 'toneandsculpt-test',
        publishableKey: 'test_BF6kqDa3BcdYX4lHpSAkA0gSmwyKlSiVs',
    },
    mixpanel: '404f100828f4f50701ba0c8375dd9948',
    stripe: 'pk_test_ETEuuZuWG9Muk5jSWeSWf5lt',
    maps: 'AIzaSyBDw-qn546y4clpL36onKfnHkZ8QZImaHE',
    partnerStack: 'pk_C9RoJPcONk7QVpLqjufWyZGNEND86IIB',
    branch: 'key_test_chVuMsGX8KxlKmdT99CixmdlsscDdFXs',
    braze: {
        apiKey: '07ce5a19-b4aa-4fa0-9c71-c805285876d8',
        sdkEndpointUrl: 'sdk.fra-01.braze.eu',
    },
    cognitoPool: 'https://cognito-idp.eu-west-2.amazonaws.com/eu-west-2_V2rj6oUvX',
    domain: 'evolveyou.app',
    mentionMeUrl: 'https://tag-demo.mention-me.com',
    stripeUrl: 'https://join-staging.evolveyou.app'
};
